import {
    type EditCommercialOpportunityResponseType,
    type EditCommercialOpportunityRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const EditCommercialOpportunity = async (params: EditCommercialOpportunityRequestType): Promise<EditCommercialOpportunityResponseType> => {
    return await axios(`${SERVER_ADDRESS}/profile/editCommercialOpportunity`, {
        method: "PUT",
        headers: getHeaders(true),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default EditCommercialOpportunity;
